import { GameStakeSelectorProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameStakeSelectorProperties";
/**
 * StakeSelectorPortraitProperties.ts
 */
export class StakeSelectorPortraitProperties extends GameStakeSelectorProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.position.set(0, 0);
        this.scale.set(1);
        this.panelProperties.position.set(162, 404);
        this.panelProperties.scale.set(1);
        this.toggleButtonProperties.position.set(658, 1568);
        this.toggleButtonProperties.scale.set(1);
    }
}
//# sourceMappingURL=StakeSelectorPortraitProperties.js.map